import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import Breadcrumbs from "@/components/feature/Breadcrumbs";

export default function NotFound() {
  return (
    <SiteLayout>
      <section className="w-full px-4 md:px-8 pt-32 md:pt-40 pb-24 text-center">
        <Breadcrumbs items={[{ label: "首页", to: "/" }, { label: "页面未找到" }]} />
        <div className="mt-10">
          <span className="mx-auto w-16 h-16 flex items-center justify-center rounded-full bg-background-100 text-primary-400">
            <i className="ri-compass-3-line text-3xl" aria-hidden="true"></i>
          </span>
          <h1 className="mt-6 font-heading text-3xl md:text-5xl font-black text-foreground-950">
            这条线索断在了这里
          </h1>
          <p className="mx-auto mt-4 max-w-xl text-sm md:text-base leading-relaxed text-foreground-500">
            你访问的页面不存在或已被移动。可以回到首页，或者直接到档案库里继续查找。
          </p>
          <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
            <Link
              to="/"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md text-sm whitespace-nowrap cursor-pointer bg-primary-500 text-background-950 hover:bg-primary-400 transition-colors"
            >
              <i className="ri-home-4-line" aria-hidden="true"></i>
              返回首页
            </Link>
            <Link
              to="/archive"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md text-sm whitespace-nowrap cursor-pointer border border-background-300 text-foreground-800 hover:border-primary-700 transition-colors"
            >
              <i className="ri-folder-history-line" aria-hidden="true"></i>
              前往档案库
            </Link>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}